import { render, staticRenderFns } from "./ReportsUnavailable.vue?vue&type=template&id=49d6797f&scoped=true&"
var script = {}
import style0 from "./ReportsUnavailable.vue?vue&type=style&index=0&id=49d6797f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d6797f",
  null
  
)

export default component.exports